(function () {
  const allSvg = (require as any).context("./svg", false, /\.svg$/);
  return allSvg.keys().map(allSvg);
})();
